import { useDrag } from "react-dnd"
import { ID } from "@nova/constants"
import { WorkspaceDragItem, WorkspaceEntityType } from "../types"
import { isDraggingWorkspaceEntity } from "../module"

type UseWorkspaceProjectDragAndDropProps = {
    id: ID
    isEditor: boolean
    isRenaming: boolean
    isInFavorites: boolean
}

export const useWorkspaceProjectDragAndDrop = ({
    id,
    isEditor,
    isRenaming,
    isInFavorites,
}: UseWorkspaceProjectDragAndDropProps) => {
    const [{ anythingIsDragging }, dragRef] = useDrag(
        () => ({
            type: WorkspaceEntityType.Project,
            item: {
                id,
                type: WorkspaceEntityType.Project,
                isFromFavorites: isInFavorites,
            } satisfies WorkspaceDragItem,
            collect: (monitor) => ({
                anythingIsDragging: isDraggingWorkspaceEntity(monitor),
            }),
            canDrag: !isRenaming && isEditor,
        }),
        [id, isRenaming, isEditor, isInFavorites]
    )

    return {
        dragRef,
        anythingIsDragging,
    }
}
